import * as React from "react";
import { InviteComponent } from "./InviteComponent";

export interface Practice {
  name: string;
  city: string | null;
  state: string | null;
  timezone: string;
  avatar_url: string;
}

export interface JobType {
  title: string;
}

export interface Job {
  id: number;
  practice: Practice;
  practice_name: string;
  job_type: JobType;
  compensation_full?: string;
}

export interface Invite {
  id: number;
  ignored: boolean;
  seen?: boolean;
  applied?: boolean;
  created_at: string;
  job: Job;
}

interface ApplicationInvitationsProps {
  invites: Invite[];
  authenticity_token: string;
}

const ApplicationInvitations: React.FC<ApplicationInvitationsProps> = ({
  invites,
  authenticity_token
}) => {
  if (invites.length === 0) {
    return (
      <div className="padding-right p-2">
        <ul className="job-list full">
          <div className="field">
            <li className="text-center">
              <img
                src="/images/missing.svg"
                alt=""
                height={100}
              />
              <div className="job-list-content text-center">
                <h4 className="fullname">No Invitations</h4>
                <p>You have no job invitations at this time.</p>
              </div>
            </li>
            <div className="clearfix"></div>
          </div>
        </ul>
      </div>
    );
  }

  return (
    <div className="padding-right">
      <ul className="job-list full">
        {invites.map(invite => (
          <InviteComponent
            key={invite.id}
            invite={invite}
            authenticity_token={authenticity_token}
          />
        ))}
      </ul>
    </div>
  );
};

export default ApplicationInvitations;
